module.exports = {"name":"Detail udalosti","icon":"<i class='material-icons'>event</i>","widget":{"type":"event-detail"}}


//////////////////
// WEBPACK FOOTER
// ./src/blocks/event-detail/event-detail.json
// module id = 328
// module chunks = 0